/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './CurveInformation.scss';
import { BodyText, Heading } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import { CurveData } from '../../../../modules/ChemicalDataController';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash';

interface CurveInformationProps {
    curveInformation: CurveData
}

const CurveInformation = ({ curveInformation }: CurveInformationProps) => {
  const { t } = useTranslation();

  if (curveInformation) {
    return (
        <div className="curve-information">
            <Heading level={isMobileOnly ? '1' : '3'}>
                {curveInformation.Name}
            </Heading>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.code')}</BodyText>
                <BodyText>{curveInformation.Code}</BodyText>
            </div>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.concentration_min')}</BodyText>
                <BodyText>{curveInformation.ConcMin}</BodyText>
            </div>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.concentration_max')}</BodyText>
                <BodyText>{curveInformation.ConcMax}</BodyText>
            </div>
            <div className="curve-information__row ">
                <BodyText>{t('curveInformation.solvent')}</BodyText>
                <BodyText>{_.upperFirst(_.toLower(curveInformation.Solvent))}</BodyText>
            </div>
            {/* <div className="curve-information__row">
                <BodyText>{t('curveInformation.reference_temp')}</BodyText>
                <BodyText>{curveInformation.Tref} °C</BodyText>
            </div>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.solubility')}</BodyText>
                <BodyText>{curveInformation.Solubility}</BodyText>
            </div> */}
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.water_based')}</BodyText>
                <BodyText>{curveInformation.Waterbased}</BodyText>
            </div>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.source')}</BodyText>
                <BodyText>{curveInformation.Source}</BodyText>
            </div>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.version')}</BodyText>
                <BodyText>{curveInformation.Version}</BodyText>
            </div>
            <div className="curve-information__row">
                <BodyText>{t('curveInformation.last_modified')}</BodyText>
                <BodyText>{curveInformation.Date}</BodyText>
            </div>
        </div>
      );
  } else return null;
};
export default CurveInformation;
